import { render, staticRenderFns } from "./LgFormCheckbox.vue?vue&type=template&id=e3d87c28&scoped=true"
import script from "./LgFormCheckbox.vue?vue&type=script&lang=js"
export * from "./LgFormCheckbox.vue?vue&type=script&lang=js"
import style0 from "./LgFormCheckbox.vue?vue&type=style&index=0&id=e3d87c28&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3d87c28",
  null
  
)

export default component.exports